import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDeskLamp: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconDeskLamp"><Path d="M15.2791 3C17.5714 3.00016 19.9445 4.3121 20.6092 6.74609C20.8936 7.78761 21.0552 8.87754 21.0008 10.0469L20.9559 11H18.0018V16H16.5018V11H13.0018V19H17.0018V21H7.00175V19H11.0018V11H3.04668L3.00273 10.0469C2.94823 8.87751 3.10896 7.78761 3.39336 6.74609C4.05812 4.31202 6.43201 3 8.72441 3H15.2791Z" fill="currentColor"/></CentralIconBase>;
});

export default IconDeskLamp;
